import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

const prepareVideosToClient = (res: IPropertyDetailsResponse) => {
    const videos = res?.videos?.map(item => item.path);
    return videos;
  };

  export default prepareVideosToClient